import React, { Component } from "react";
import { unparam } from "../../../utils/common";
import { Button } from 'antd';
import Tabs from "components/tabs";
import Bulk from "./reportItems/bulk";
import Mood from "./reportItems/mood";
import Character from "./reportItems/character";
import Mapping from "./reportItems/mapping";
import RiasecModel from "./reportItems/riasecModel";

const { TabPanel } = Tabs;

class App extends Component {
	state = {

    }

    componentDidMount(){
    }

	// 下载报告
	downloadReport = () => {
        // window.open("/oivi/account/downloadVideoReport");
        //获取页面参数
        const queryString = unparam(location.search);
		window.open("/oivi/api/file/videoReport/pdf?accountId=" + queryString.accountId);
	}

    render() {
        const { themeColor, summary, i18n, isHuman } = this.props;

        const operations = (
            <Button className="report-download" onClick={this.downloadReport} style={{color: themeColor, borderColor: themeColor}}>
                {i18n.report.download}
            </Button>
        )

        return (
            <div className="report-wrap">
                {isHuman ? <Tabs themeColor={themeColor}
                    tabBarExtraContent={operations}>
                    <TabPanel tab={i18n.report.summary}>
                        <Bulk data={summary.video_summary || {}} i18n={i18n} />
                    </TabPanel>
                    <TabPanel tab={i18n.report.emotions}>
                        <Mood data={summary.emotions_average || {}} i18n={i18n} />
                    </TabPanel>
                    <TabPanel tab={i18n.report.characteristics}>
                        <Character data={summary.characteristics_average || {}} i18n={i18n} />
                    </TabPanel>
                    <TabPanel tab={i18n.report.mapping}>
                        <Mapping data={summary.mapping || {}} i18n={i18n} themeColor={themeColor} />
                    </TabPanel>
                    <TabPanel tab={i18n.report.RIASECModel}>
                        <RiasecModel data={summary.RIASEC || {}} i18n={i18n} />
                    </TabPanel>
                </Tabs> : operations}
            </div>
        );
    }
}

export default App;
